
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import ButtonVue from "@/lib/Button.vue";
import ModalVue from "@/Modal.vue";
import { RouterHistory } from './RouterHistory';
const history: RouterHistory = new RouterHistory().class();

@Component({ components: { ButtonVue, ModalVue } })
export default class HistoryVue extends Vue { 
    key_hist=11;
    h: RouterHistory = history;
    routes = this.h.list
    active_key=false;

    async mounted() {   
    }

    created() { bus.register("history_changed",this.refresh)    }
    beforeDestroy() {  bus.remove("history_changed",this.refresh)    }  

    async refresh() {
      this.routes = this.h.list
      this.key_hist++
    }    

}
